import { useRef } from 'react'

import type { AppParams } from './types'
import { parseAppParams } from './utils'

/**
 * Parses the App URL looking for relevant parameters that will eventually dictate the App
 * behaviour and the associated resources to be loaded.
 *
 * TODO: add full support for data injection and context data
 * TODO: handle potential exception with error boundary
 */
export const useAppParams = (): Readonly<AppParams> => {
  const appParams = useRef<AppParams>(
    // parse params from URL or token
    parseAppParams(window.location.search)
  )

  // enforces immutability
  return Object.freeze(structuredClone(appParams.current))
}
